import intl from "react-intl-universal";
import { formatNumber } from "utils/format";
import { DescriptionText, HighlightBox, SectionContent } from "../../styled";

interface AppliedAdjustments {
  quantityCalculationFormula?: string;
  finalQuantity?: number;
  adjustmentExplanation?: string;
}

interface AppliedAdjustmentsProps {
  appliedAdjustments?: AppliedAdjustments;
}

const AppliedAdjustments = (props: AppliedAdjustmentsProps) => {
  const { appliedAdjustments } = props;

  if (!appliedAdjustments) return null;

  const { quantityCalculationFormula, finalQuantity, adjustmentExplanation } = appliedAdjustments;

  return (
    <SectionContent>
      <DescriptionText $fontSize="0.75rem" $fontWeight={700}>
        {intl.get("stocks.suggestionContext.appliedAdjustments.title")}
      </DescriptionText>

      <DescriptionText>{`${quantityCalculationFormula}`}</DescriptionText>
      <HighlightBox>
        <DescriptionText $fontWeight={700}>
          {intl.get("stocks.suggestionContext.appliedAdjustments.finalQuantityLabel")}
        </DescriptionText>

        <DescriptionText>
          {finalQuantity !== undefined ? formatNumber(finalQuantity) : ""}
        </DescriptionText>
      </HighlightBox>

      <DescriptionText>{`${adjustmentExplanation}`}</DescriptionText>
    </SectionContent>
  );
};

export default AppliedAdjustments;
